import type { ButtonHTMLAttributes, ReactNode } from "react";

import "./Button.css";

type Variant = "primary" | "secondary" | "ghost" | "danger" | "sidebar" | "sidebar-ghost";

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  icon?: ReactNode;
}

export default function Button({
  variant = "primary",
  icon,
  children,
  className = "",
  ...rest
}: Props) {
  return (
    <button className={`btn btn--${variant} ${className}`} {...rest}>
      {icon}
      {children}
    </button>
  );
}
